exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".welcome{position:absolute;width:640px;height:240px;top:50%;left:50%;margin:-150px 0 0 -320px}.welcome__installation-name{white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/src?{}!./node_modules/sass-loader/lib/loader.js?sourcemap&outputStyle=expanded!./src/pages/welcome/welcome.scss
// module id = 828
// module chunks = 0